/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PcmsHubLifecycleStatusRequest } from './pcms-hub-lifecycle-status-request';
import { PcmsHubDemographicSnapshotRequest } from './pcms-hub-demographic-snapshot-request';


export interface PcmsHubJuvenileReferralOpenRequest { 
    /**
     * Exact opaque CRD Program OID; preserve case and value without normalization
     */
    crdProgramId: string;
    /**
     * Exact opaque CRD ProgramReferral OID when correlation already exists; preserve case and value without normalization
     */
    crdReferralId?: string | null;
    demographicSnapshot: PcmsHubDemographicSnapshotRequest;
    disposition: PcmsHubJuvenileReferralOpenRequest.DispositionEnum;
    pcmsIndividualId: number;
    pcmsReferralId: number;
    pcmsServiceProviderId: number;
    referralDate: string;
    referralEndDate?: string;
    status: PcmsHubLifecycleStatusRequest;
    statusDate: string;
}
export namespace PcmsHubJuvenileReferralOpenRequest {
    export const DispositionEnum = {
        Open: 'OPEN',
        CancelledByPcms: 'CANCELLED_BY_PCMS',
        ClosedOther: 'CLOSED_OTHER'
    } as const;
    export type DispositionEnum = typeof DispositionEnum[keyof typeof DispositionEnum];
}


